<template>
  <div class="hyp-overflow-tabs">
    <v-tabs
      v-model="selectedMenuItem"
      optional
      centered
      ref="tabs"
      :show-arrows="true"
    >
      <v-tab
        class="px-0 mx-0 type-tabs"
        v-for="filter in menuItems"
        :key="filter"
        :href="'#' + filter"
        :disabled="disabled || selectedMenuItem === filter"
        :class="[
          selectedMenuItem === filter ? 'selected' : '',
          menuItemsWidthClass,
        ]"
      >
        {{ filter }}
      </v-tab>
    </v-tabs>
    <v-tabs
      v-if="moreMenuItems.length"
      optional
      v-model="selectedMenuItem"
      centered
      ref="tabs"
      :show-arrows="true"
    >
      <v-tab
        class="px-0 mx-0 type-tabs"
        v-for="filter in moreMenuItems"
        :key="filter"
        :href="'#' + filter"
        :disabled="disabled || selectedMenuItem === filter"
        :class="[
          selectedMenuItem === filter ? 'selected' : '',
          moreMenuItemsWidthClass,
        ]"
      >
        {{ filter }}
      </v-tab>
    </v-tabs>
  </div>
</template>
<script>
import { compact } from "lodash";

const EMITTED_ACTIONS = {
  SELECTED_MENU: "selected-menu",
};

export default {
  name: "OverflowTabs",
  components: {},
  props: {
    orderedMenuItems: {
      type: Array,
    },
    menuItemsCount: {
      type: Number,
    },
    defaultSelectedMenuItem: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedMenuItem: this.defaultSelectedMenuItem,
      menuItems: this.orderedMenuItems.slice(
        0,
        this.orderedMenuItems.length > this.menuItemsCount
          ? this.menuItemsCount
          : this.orderedMenuItems.length
      ),
      moreMenuItems: this.orderedMenuItems.slice(
        this.menuItemsCount,
        this.orderedMenuItems.length
      ),
    };
  },
  computed: {
    menuItemsWidthClass() {
      return "type-tabs-count-" + this.menuItems.length;
    },
    moreMenuItemsWidthClass() {
      return "type-tabs-count-" + this.moreMenuItems.length;
    },
  },
  watch: {
    selectedMenuItem: {
      async handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit(EMITTED_ACTIONS.SELECTED_MENU, {
            item: this.selectedMenuItem,
          });
        }
      },
      deep: true,
    },
    defaultSelectedMenuItem: {
      async handler(val) {
        this.selectedMenuItem = this.defaultSelectedMenuItem;
      },
    },
  },
};
</script>

<style>
.hyp-overflow-tabs > .v-tabs .v-slide-group__prev.v-slide-group__prev--disabled,
.hyp-overflow-tabs
  > .v-tabs
  .v-slide-group__next.v-slide-group__next--disabled {
  display: none !important;
}
.hyp-overflow-tabs > .v-tabs > .v-tabs-bar {
  height: 35px !important;
}
.hyp-overflow-tabs > .v-slide-group__next,
.v-slide-group__prev {
  min-width: 12px !important;
  flex: 0 1 12px !important;
}
</style>
<style scoped lang="scss">
.type-tabs {
  font-size: smaller;
  padding-right: 2px !important;
  padding-left: 8px !important;
  justify-content: left;
  text-align: justify;
  border: 0.1px solid #f0f0f0;
}
.type-tabs.type-tabs-count-4 {
  width: 25% !important;
}
.type-tabs.type-tabs-count-3 {
  width: 33.33% !important;
}
.type-tabs.type-tabs-count-2 {
  width: 50% !important;
}
.type-tabs.v-tab--active.selected {
  color: $primary-color;
  opacity: 1;
}
@media only screen and (max-width: 1450px) {
  .type-tabs.v-tab {
    max-width: min-content !important;
  }
}
@media only screen and (max-width: 1250px) {
  .type-tabs.v-tab {
    max-width: min-content !important;
    font-size: xx-small !important;
  }
}
@media only screen and (max-width: 1050px) {
  .type-tabs.v-tab {
    max-width: min-content !important;
    min-width: unset !important;
    font-size: xx-small !important;
  }
}
</style>
